import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-play-80"] || "codicon-play-80")} viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><circle stroke="#FFF" strokeWidth="2" cx="40" cy="40" r="39" /><path fill="#FFF" d="M36.556 31.706l13.071 8.141-13.071 8.142z" /></g></svg>;